import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalServiceClassType } from '@app/services/api/api.types';
import { toLabel } from '@app/ui/pipes/label.pipe';

@Component({
  selector: 'service-class-badge',
  templateUrl: './service-class-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceClassBadgeComponent {
  @Input()
  set serviceClasses(value: PortalServiceClassType[]) {
    const serviceClasses = new Set(value);

    this.iconPath = this.getIconPath(serviceClasses);

    this.serviceClass = this.getServiceClass(serviceClasses);
  }

  protected serviceClass: string;
  protected iconPath: string;

  private getIconPath(serviceClasses: Set<string>): string {
    if (
      serviceClasses.has(PortalServiceClassType.PREMIUM_ECONOMY) ||
      serviceClasses.has(PortalServiceClassType.ECONOMY) ||
      serviceClasses.has(PortalServiceClassType.UNDEFINED) ||
      serviceClasses.has(PortalServiceClassType.MIXED)
    ) {
      return 'seat';
    } else {
      return 'airline_seat_flat';
    }
  }

  private getServiceClass(serviceClasses: Set<string>): string {
    return [...serviceClasses].map((serviceClass) => toLabel(serviceClass)).join(' + ');
  }
}
